// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2WUiF","tab":"ProcedureTabs_tab__30r92"};